export { default as ClientInventoryResourcePage } from './ClientResource';
export { default as ClientInventoryTrayPage } from './ClientTray';
export { default as ClientInventorySeedPage } from './ClientSeed';
export { default as ClientInventoryRootPage } from './Root';
